module.exports = __webpack_public_path__ + "static/specifiers-bg-06296f910fdf355bdf37f13c5b7e04f0.png";